module.exports = __webpack_public_path__ + "static/media/241674.d7766f12.jpg";